module.exports = __webpack_public_path__ + "img/robot-land.6a0d9b8e.webp";